import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Motion";
import { SERVICES } from "@/data/site";

export default function ServiceGrid({ compact = false }) {
  return (
    <div data-testid="service-grid" className="grid md:grid-cols-3 gap-6">
      {SERVICES.map((s, i) => {
        const Icon = Icons[s.icon] || Icons.Sparkles;
        return (
          <Reveal key={s.key} delay={(i % 3) * 0.08}>
            <Link
              to="/quote"
              data-testid={`service-card-${s.key}`}
              className="group block h-full bg-white border border-slate-200 rounded-3xl p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-30px_rgba(28,42,57,0.35)] hover:border-[#0D9488]/40"
            >
              <div className="w-14 h-14 rounded-2xl bg-[#E8F1EB] flex items-center justify-center mb-6 transition-colors duration-500 group-hover:bg-[#0D9488]">
                <Icon size={26} className="text-[#0D9488] transition-colors duration-500 group-hover:text-white" strokeWidth={1.6} />
              </div>
              <h3 className="font-display font-medium text-2xl text-[#1C2A39] mb-3">{s.title}</h3>
              <p className="text-[#475569] text-sm leading-relaxed mb-5">{s.blurb}</p>
              {!compact && (
                <ul className="space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-[#1C2A39]">
                      <Icons.Check size={15} className="text-[#0D9488]" /> {p}
                    </li>
                  ))}
                </ul>
              )}
              <span className="inline-flex items-center gap-1.5 mt-6 text-sm font-semibold text-[#0D9488]">
                Get a quote <Icons.ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        );
      })}
    </div>
  );
}
